import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
import {
  Table,
  Space,
  Breadcrumb,
  Select,
  Input,
  Button,
  Row,
  Col,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
const { Option } = Select;
class RMPurchaseList extends Component {
  constructor() {
    super();
  }
  state = {
    details: [],
    newdetails: [],
    data: [],
  };

  onChange = async (value) => {
    this.search(value);
  };
  componentDidMount() {
    const details = [];
    axios
      .get(`${getServerUrl()}/master/getrmpurchaseorder`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        this.setState({ details });
      });
  }
  componentDidUpdate() {
    console.log("New Data");
  }
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  render() {
    const data = this.state.details;
    const dataDropDown = this.state.details;
    const dropDownOptions = dataDropDown.map((dataDrop) => {
      return (
        <Option value={dataDrop.process_id}>{dataDrop.process_name}</Option>
      );
    });
    const columns = [
      {
        title: "Purchase Order",
        dataIndex: "vendorinvoice",
        key: "vendorinvoice",
        width: "30%",
        ...this.getColumnSearchProps("vendorinvoice"),
      },
      {
        title: "Contractor Name",
        dataIndex: "contractor_name",
        key: "contractor_name",
        width: "20%",
        ...this.getColumnSearchProps("contractor_name"),
      },
      {
        title: "Purchase Date",
        dataIndex: "po_date",
        key: "po_date",
        width: "20%",
        ...this.getColumnSearchProps("po_date"),
      },
      {
        title: "Balance PO Quantity",
        dataIndex: "balancepoqty",
        key: "balancepoqty",
        width: "20%",
        ...this.getColumnSearchProps("balancepoqty"),
      },

      {
        title: "Action",
        dataIndex: "p_id",
        key: "p_id",
        render: (text, record) => (
          <Space size="middle">
            <NavLink to={"/viewrmpurchaseoder/" + record.p_id}>View</NavLink>
          </Space>
        ),
      },
    ];
    function onSearch(val) {
      console.log("search:", val);
    }
    return (
      <div>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
          <Breadcrumb.Item>Purchase Settings</Breadcrumb.Item>
          <Breadcrumb.Item>Raw Material Purchase Order</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <h2 className="titles">
            VIEW RAW MATERIAL PURCHASE <span>ORDER</span>
          </h2>
          <Row></Row>
          <Space></Space>
          <br />
          <Table columns={columns} dataSource={data}></Table>
        </div>
      </div>
    );
  }
}

export default RMPurchaseList;
